function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var V = Object.defineProperty;
var i = Object.getOwnPropertySymbols;
var e = Object.prototype.hasOwnProperty,
    h = Object.prototype.propertyIsEnumerable;

var n = function n(l, C, t) {
  return C in l ? V(l, C, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : l[C] = t;
},
    r = function r(l, C) {
  for (var t in C || (C = {})) {
    e.call(C, t) && n(l, t, C[t]);
  }

  if (i) {
    var _iterator = _createForOfIteratorHelper(i(C)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var t = _step.value;
        h.call(C, t) && n(l, t, C[t]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return l;
};

import * as o from "react";

function w(l) {
  return o.createElement("svg", r({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, l), o.createElement("path", {
    d: "M14.9818 15.7445L11.5455 13.4595C12.6909 12.6598 13.4545 11.5173 13.4545 10.1463V9.23231C13.4545 7.06157 11.6727 5.11933 9.25455 5.00508C6.70909 4.89083 4.54545 6.71882 4.54545 9.00381V10.1463C4.54545 11.5173 5.30909 12.6598 6.45455 13.4595L3.01818 15.8588C2.38182 16.3158 2 17.0013 2 17.6868V19.8575C2 20.543 2.50909 21 3.27273 21H14.7273C15.4909 21 16 20.543 16 19.8575V17.5725C16 16.887 15.6182 16.2015 14.9818 15.7445Z",
    fill: "black"
  }), o.createElement("path", {
    d: "M20.8088 9.12456L18.4265 7.79584C18.9559 7.35293 19.3529 6.68857 19.3529 5.91349V4.91694C19.3529 3.58822 18.1618 2.2595 16.5735 2.03805C14.9853 1.81659 13.6618 2.59168 13 3.58822C14.4559 4.69549 15.3824 6.24567 15.3824 8.01729V9.12456C15.3824 10.1211 15.1176 11.1176 14.5882 11.8927C14.5882 11.8927 16.1765 12.8893 16.1765 13H20.6765C21.4706 13 22 12.5571 22 11.8927V11.0069C22 10.2318 21.6029 9.56747 20.8088 9.12456Z",
    fill: "black"
  }));
}

export { w as ReactComponent };